import { render, staticRenderFns } from "./CbsForgotPassword.vue?vue&type=template&id=38e5f7da"
import script from "./CbsForgotPassword.vue?vue&type=script&lang=js"
export * from "./CbsForgotPassword.vue?vue&type=script&lang=js"
import style0 from "./CbsForgotPassword.vue?vue&type=style&index=0&id=38e5f7da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports